import {
  Modal,
  Form,
  Select,
  Button,
  Typography,
  Radio,
  Checkbox,
  Avatar,
  message,
} from "antd";
import eventicon from "../../Assets/calender/Event-icon.png";
import taskicon from "../../Assets/calender/Task-icon.png";
import checkWhiteIcon from "../../Assets/calender/checkWhiteIcon.png";
import "./FilterModal.css";
import { CheckOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import { URL } from "../../helper/Mainurl";
const FilterModal = ({
  activeFilters,
  isFilterModalOpen,
  closeFilterModal,
  applyFilters,
  startDate,
  endDate,
  getCalenderData,
  calendarMetaData,
}) => {
  const token = localStorage.getItem("authToken");
  const [form] = Form.useForm();
  const { Title } = Typography;
  // Separate state variables
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedPriorities, setSelectedPriorities] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [filterMetaData, setFilterMetaData] = useState([]);
  const [filters, setFilters] = useState({
    category: null,
    priorities: [],
    status: null,
    colors: [],
    selectedUsers: [],
  });
  // Fetch metadata for filtering options
  useEffect(() => {
    setFilterMetaData(calendarMetaData);
  }, [calendarMetaData]); // Re-fetch if token changes
  // console.log(filterMetaData, "filterMetaData");

  useEffect(() => {
    if (isFilterModalOpen && activeFilters) {
      setSelectedCategory(activeFilters.category || null);
      setSelectedPriorities(activeFilters.priorities || []);
      setSelectedStatus(activeFilters.status || null);
      setSelectedColors(activeFilters.colors || []);
      setSelectedUsers(activeFilters.selectedUsers || []);
    }
  }, [isFilterModalOpen, activeFilters]);

  // Helper function to update filters
  const updateFilter = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };
  const handlePrioritySelection = (priorityId) => {
    setSelectedPriorities(
      (prev) =>
        prev.includes(priorityId)
          ? prev.filter((id) => id !== priorityId) // Remove if already selected
          : [...prev, priorityId] // Add if not selected
    );
  };
  const handleColorSelection = (id) => {
    // setSelectedColors((prev) =>
    //   prev.includes(Number(id)) ? prev.filter((item) => item !== Number(id)) : [...prev, Number(id)]
    // );
    setSelectedColor(id);
  };
  const users = [
    // { id: 1, name: "John Doe", email: "john.doe@example.com", avatar: "https://i.pravatar.cc/50?img=1" },
    // { id: 2, name: "Jane Smith", email: "jane.smith@example.com", avatar: "https://i.pravatar.cc/50?img=2" },
    // { id: 3, name: "Alice Johnson", email: "alice.johnson@example.com", avatar: "https://i.pravatar.cc/50?img=3" },
    // { id: 4, name: "Bob Brown", email: "bob.brown@example.com", avatar: "https://i.pravatar.cc/50?img=4" }
  ];
  const handleUserSelection = (userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };
  const handleApply = async () => {
    const category = selectedCategory;
    const status = selectedStatus;
    const priorities = selectedPriorities;
    // .length > 0 ? selectedPriorities : []

    const payload = {
      priorities: selectedPriorities,
      //   .length > 0 ? selectedPriorities : [],
      status: selectedStatus,
      // colors: selectedColors.length > 0 ? selectedColors : [],
      selectedUsers: selectedUsers.length > 0 ? selectedUsers : [],
      category: selectedCategory,
    };
    applyFilters(priorities, status, category, selectedColor); // Pass filters back to Calender
    closeFilterModal();
    // console.log("Filters applied:", payload);
  };
  const handleReset = () => {
    form.resetFields(); // Reset Ant Design form fields (if used)
    setSelectedCategory(null);
    setSelectedPriorities([]);
    setSelectedStatus(null);
    setSelectedColors([]);
    setSelectedColor(null);
    setSelectedUsers([]);

    // closeFilterModal(true);
    // getCalenderData(startDate, endDate);
  };
  const data = {
    categories1: [
      { id: 1, label_name: "Task", value: "task" },
      { id: 2, label_name: "Event", value: "event" },
    ],

    progress_status: filterMetaData?.progress_status || [
      { id: 26, label_name: "Pending" },
      { id: 27, label_name: "Completed" },
    ],
    priority: filterMetaData?.priority || [
      { id: 22, label_name: "No priority" },
      { id: 23, label_name: "High" },
      { id: 24, label_name: "Medium" },
      { id: 25, label_name: "Low" },
    ],
    color_code: filterMetaData?.colors,
  };
  // console.log("Selected Color:", selectedColor);
  return (
    <Modal
      className="filter-modal"
      open={isFilterModalOpen}
      onCancel={closeFilterModal}
      footer={null}
    >
      <div className="filter-header">
        <div className="filter-head">
          <Title level={3}>Filters</Title>
        </div>
        <div className="filterHeadBtn">
          <Button className="resetBtn" onClick={handleReset}>
            Reset
          </Button>
        </div>
      </div>

      <div className="optionFilterSection">
        <Title className="filterInnerTitle" level={4}>
          Category
        </Title>
        <Radio.Group
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          optionType="button"
          buttonStyle="solid"
          className="category-group"
        >
          {data.categories1.map((category) => (
            <Radio.Button
              className="selectFilterRadio"
              key={category.value}
              value={category.value}
            >
              {category.id === 1 ? ( // If ID is 1, show Task icon
                <img
                  src={taskicon}
                  alt="Task"
                  width={18}
                  style={{ marginRight: 5 }}
                />
              ) : category.id === 2 ? ( // If ID is 2, show Event icon
                <img
                  src={eventicon}
                  alt="Event"
                  width={18}
                  style={{ marginRight: 5 }}
                />
              ) : null}
              {category.label_name}
            </Radio.Button>
          ))}
        </Radio.Group>
      </div>
      <div className="optionFilterSection">
        <Title className="filterInnerTitle" level={4}>
          Priority
        </Title>
        <Radio.Group
          value={selectedPriorities}
          onChange={(e) => setSelectedPriorities(e.target.value)}
          optionType="button"
          buttonStyle="solid"
          className="priority-radio"
          style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}
        >
          {filterMetaData.priority?.map((item, index) => (
            <Radio.Button
              className="selectFilterRadio"
              key={item.id}
              value={item.id}
            >
              {item.label_name}
            </Radio.Button>
          ))}
        </Radio.Group>
      </div>
      <div className="optionFilterSection">
        <Title className="filterInnerTitle" level={4}>
          Status
        </Title>
        <Radio.Group
          value={selectedStatus}
          onChange={(e) => setSelectedStatus(e.target.value)}
          optionType="button"
          buttonStyle="solid"
        >
          {filterMetaData.progress_status?.map((item, index) => (
            <Radio.Button
              className="selectFilterRadio"
              key={item.id}
              value={item.id}
            >
              {item.label_name}
            </Radio.Button>
          ))}
        </Radio.Group>
      </div>
      <div className="optionFilterSection">
        <Title className="filterInnerTitle" level={4}>
          Color
        </Title>
        <div className="color-options">
          {data?.color_code?.map((color) => (
            <div
              key={color.id}
              className={`color-circle ${selectedColor === color.id ? "selected" : ""
                }`}
              style={{ backgroundColor: color.value }}
              onClick={() => handleColorSelection(color.id)}
            >
              {selectedColor === color.id && (
                <CheckOutlined className="check-icon colorSelect" />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* <div className="optionFilterSection">
        <Title className="filterInnerTitle" level={4}>
          Other Calendars
        </Title>
        <div className="user-list">
          {users.map((user) => (
            <div key={user.id} className="user-item">
              <div className="userFilterData">
                <Avatar src={user.avatar} alt={user.name} size={40} />
                <div className="user-info">
                  <span className="user-email">{user.email}</span>
                </div>
              </div>
              <Checkbox
                className="userFilterCheckbox"
                checked={selectedUsers.includes(user.id)}
                onChange={() => handleUserSelection(user.id)}
              />
            </div>
          ))}
        </div>
      </div> */}

      <div className="modalBottomBtn">
        <Button
          className="cancelBtn"
          onClick={closeFilterModal}
          style={{ marginRight: 8 }}
        >
          Cancel
        </Button>
        <Button className="applyBtn" type="primary" onClick={handleApply}>
          Apply
        </Button>
      </div>
    </Modal>
  );
};

export default FilterModal;
